import FormPageTemplate from './FormPageTemplate'

const ImpactWindowsNewProjectPage = () => (
    <FormPageTemplate
        titleKey="admin.monday.impact_windows_new_project"
        subtitleKey="admin.monday.impact_windows_form_desc"
        defaultFormType="construction_new_project"
        returnPath="/impact-windows"
    />
)

export default ImpactWindowsNewProjectPage
